<!-- FAD MASIVO DESKTOP -->
<div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
    <div class="billing-info-container">
        <div class="title" style="margin-bottom: 20px">
            <p>Datos de facturación</p>
        </div>

        <div class="form" [formGroup]="form"
             *ngIf="!billingAdded && addBilling === true && this.sessionService.getCountryData()">
            <mat-form-field class="w-25" appearance="outline">
                <mat-label>País</mat-label>
                <mat-select placeholder="Selecciona" required formControlName="country">
                    <mat-option>--</mat-option>
                    <mat-option *ngFor="let countrie of countries"
                                value='{{countrie.name_es}}'>{{countrie.name_es}}</mat-option>
                </mat-select>
                <mat-error>Campo requerido.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-30" appearance="outline">
                <mat-label>Estado</mat-label>
                <input maxlength="50" appOnlyLetters formControlName="state" required matInput autocomplete="off"
                       type="text">
                <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-40" appearance="outline">
                <mat-label>Ciudad</mat-label>
                <input maxlength="50" appOnlyLetters formControlName="city" required matInput autocomplete="off"
                       type="text">
                <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-25" appearance="outline">
                <mat-label>Código postal</mat-label>
                <input appOnlyNumbers minlength="4" maxlength="8"  required formControlName="code" matInput
                       autocomplete="off"
                       type="text">
                <mat-error
                        *ngIf="!form.controls.code.hasError('required') && form.controls.code.hasError('minlength')">
                    Longitud mínima de 4 dígitos
                </mat-error>
                <mat-error
                        *ngIf="form.controls.code.hasError('required')">
                    Campo requerido.
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-70" appearance="outline">
                <mat-label>Dirección</mat-label>
                <input maxlength="50" appToUppercase required formControlName="address" matInput autocomplete="off"
                       type="text">
                <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-55" appearance="outline">
                <mat-label>RFC</mat-label>
                <input required appToUppercase formControlName="rfc" maxlength="13" matInput autocomplete="off"
                       type="text">
                <mat-error>Digita tu RFC.</mat-error>
                <mat-error *ngIf="!form.controls.rfc.hasError('required') && form.controls.rfc.hasError('rfcFormat')">
                    RFC
                    inválido
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-40" appearance="outline">
                <mat-label>Razón social</mat-label>
                <input maxlength="50" required appToUppercase formControlName="businessName" matInput autocomplete="off"
                       type="text">
                <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-100" appearance="outline">
                <mat-label>USO de CFDI</mat-label>
                <mat-select placeholder="Selecciona" required formControlName="cfdiUses">
                    <mat-option>--</mat-option>
                    <mat-option value="G01 Adquisición de mercancías">G01 Adquisición de mercancías</mat-option>
                    <mat-option value="G02 Devoluciones, descuentos o bonificaciones">G02 Devoluciones, descuentos o
                        bonificaciones
                    </mat-option>
                    <mat-option value="G03 Gastos en general">G03 Gastos en general</mat-option>
                    <mat-option value="I01 Construcciones">I01 Construcciones</mat-option>
                    <mat-option value="I02 Mobiliario y equipo de oficina por inversiones">I02 Mobiliario y equipo de
                        oficina por inversiones
                    </mat-option>
                    <mat-option value="I03 Equipo de transporte">I03 Equipo de transporte</mat-option>
                    <mat-option value="I04 Equipo de cómputo y accesorios">I04 Equipo de cómputo y accesorios
                    </mat-option>
                    <mat-option value="I05 Dados, troqueles, moldes, matrices y herramental">I05 Dados, troqueles,
                        moldes, matrices y herramental
                    </mat-option>
                    <mat-option value="I06 Comunicaciones telefónicas">I06 Comunicaciones telefónicas</mat-option>
                    <mat-option value="I07 Comunicaciones satelitales">I07 Comunicaciones satelitales</mat-option>
                    <mat-option value="I08 Otra maquinaria y equipo">I08 Otra maquinaria y equipo</mat-option>
                    <mat-option value="D01 Honorarios médicos, dentales y gastos hospitalarios">D01 Honorarios médicos,
                        dentales y gastos hospitalarios
                    </mat-option>
                    <mat-option value="D02 Gastos médicos por incapacidad o discapacidad">D02 Gastos médicos por
                        incapacidad o discapacidad
                    </mat-option>
                    <mat-option value="D03 Gastos funerales">D03 Gastos funerales</mat-option>
                    <mat-option value="D04 Donativos">D04 Donativos</mat-option>
                    <mat-option
                            value="D05 Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)">
                        D05 Intereses reales efectivamente pagados por créditos hipotecarios (casa
                        habitación)
                    </mat-option>
                    <mat-option value="D06 Aportaciones voluntarias al SAR">D06 Aportaciones voluntarias al SAR
                    </mat-option>
                    <mat-option value="D07 Primas por seguros de gastos médicos">D07 Primas por seguros de gastos
                        médicos
                    </mat-option>
                    <mat-option value="D08 Gastos de transportación escolar obligatoria">D08 Gastos de transportación
                        escolar obligatoria
                    </mat-option>
                    <mat-option
                            value="D09 Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones">
                        D09 Depósitos en cuentas para el ahorro, primas que tengan como base planes de
                        pensiones
                    </mat-option>
                    <mat-option value="D10 Pagos por servicios educativos (colegiaturas)">D10 Pagos por servicios
                        educativos (colegiaturas)
                    </mat-option>
                    <mat-option value="P01 Por definir">P01 Por definir</mat-option>
                </mat-select>
                <mat-error>Campo requerido.</mat-error>
            </mat-form-field>
            <div class="actions">
                <div class="check">
                    <mat-checkbox [(ngModel)]="acepptTerms" [ngModelOptions]="{standalone: true}"> Acepto el
                    </mat-checkbox>
                    <a class="link" [routerLink]="['/aviso-de-privacidad']" target="_blank">Aviso de Privacidad y los
                        Términos y
                        condiciones.</a>
                </div>
            </div>
        </div>

        <div class="form" [formGroup]="formLatam"
             *ngIf="!billingAdded && addBilling === true && !this.sessionService.getCountryData()">
            <mat-form-field class="w-25" appearance="outline">
                <mat-label>País</mat-label>
                <mat-select placeholder="Selecciona" required formControlName="country">
                    <mat-option>--</mat-option>
                    <mat-option *ngFor="let countrie of countries"
                                value='{{countrie.name_es}}'>{{countrie.name_es}}</mat-option>
                </mat-select>
                <mat-error>Campo requerido.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-30" appearance="outline">
                <mat-label>Estado</mat-label>
                <input maxlength="50" appOnlyLetters formControlName="state" required matInput autocomplete="off"
                       type="text">
                <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-40" appearance="outline">
                <mat-label>Ciudad</mat-label>
                <input maxlength="50" appOnlyLetters formControlName="city" required matInput autocomplete="off"
                       type="text">
                <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-25" appearance="outline">
                <mat-label>Código postal</mat-label>
                <input appToUppercase minlength="4" maxlength="8" required formControlName="code" matInput
                       autocomplete="off"
                       type="text">
                <mat-error
                        *ngIf="!formLatam.controls.code.hasError('required') && formLatam.controls.code.hasError('minlength')">
                    Longitud mínima de 4 dígitos
                </mat-error>
                <mat-error
                        *ngIf="formLatam.controls.code.hasError('required')">
                    Campo requerido.
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-70" appearance="outline">
                <mat-label>Dirección</mat-label>
                <input maxlength="50" appToUppercase required formControlName="address" matInput autocomplete="off"
                       type="text">
                <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-55" appearance="outline">
                <mat-label>TAX CODE / IDENTIFICADOR FISCAL</mat-label>
                <input required appToUppercase formControlName="rfc" minlength="5" matInput autocomplete="off"
                       type="text">
                <mat-error>Campo requerido.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-40" appearance="outline">
                <mat-label>Razón social</mat-label>
                <input maxlength="50" required appToUppercase formControlName="businessName" matInput autocomplete="off"
                       type="text">
                <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
            </mat-form-field>
            <div class="actions">
                <div class="check">
                    <mat-checkbox [(ngModel)]="acepptTerms" [ngModelOptions]="{standalone: true}"> Acepto el
                    </mat-checkbox>
                    <a class="link" [routerLink]="['/aviso-de-privacidad']" target="_blank">Aviso de Privacidad</a> y
                    los
                    <a class="link" [routerLink]="['/terminos-y-condiciones']" target="_blank">Términos y
                        condiciones.</a>
                </div>
            </div>
        </div>

        <div class="form" *ngIf="addBilling === false">
            <div class="no-data">SIN DATOS DE FACTURACIÓN</div>
        </div>

        <div class="form">
            <div class="edit-btn">
                <button *ngIf="!billingDataValid" mat-raised-button (click)="medataAdd()"
                        class="black-button">{{ !addBilling ? 'AGREGAR DATOS' : 'NO AGREGAR'}}</button>
                <button id="agregar_datos_facturacion" style="margin-left: calc( 100% - 340px );"
                        *ngIf="!billingAdded && addBilling === true && this.sessionService.getCountryData()"
                        [disabled]="form.invalid || !acepptTerms" mat-raised-button
                        (click)="saveData()" class="black-button">
                    CONTINUAR
                </button>
                <button id="agregar_datos_facturacion_latam" style="margin-left: calc( 100% - 340px );"
                        *ngIf="!billingAdded && addBilling === true && !this.sessionService.getCountryData()"
                        [disabled]="formLatam.invalid || !acepptTerms" mat-raised-button
                        (click)="saveData()" class="black-button">
                    CONTINUAR
                </button>
            </div>
        </div>

        <div class="billing-added flex" *ngIf="billingAdded && addBilling === true">
            <div class="item">
                <div class="info">
                    <p class="title">PAÍS</p>
                    <p>{{billingData?.country}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">CÓDIGO POSTAL</p>
                    <p>{{billingData?.code}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">ESTADO</p>
                    <p>{{billingData?.state}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item" *ngIf="this.sessionService.getCountryData()">
                <div class="info">
                    <p class="title">RFC</p>
                    <p>{{billingData?.rfc}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item" *ngIf="!this.sessionService.getCountryData()">
                <div class="info">
                    <p class="title">TAX CODE / IDENTIFICADOR FISCAL</p>
                    <p>{{billingData?.rfc}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">CIUDAD</p>
                    <p>{{billingData?.city}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">DIRECCIÓN</p>
                    <p>{{billingData?.address}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>
        </div>
        <div class="form">
            <div class="edit-btn">
                <button mat-raised-button *ngIf="billingDataValid" (click)="refreshEmpty()" class="white-button">
                    EDITAR
                </button>
            </div>
        </div>
    </div>
</div>

<!-- FAD MASIVO RESPONSIVO -->
<div class="fad-movil" *ngIf="isMobile === true  || isTablet === true">

    <div class="content-res">
        Datos de facturación
    </div>

    <div class="form" [formGroup]="form"
         *ngIf="!billingAdded && addBilling === true && this.sessionService.getCountryData()">
        <mat-form-field class="w-25" appearance="outline">
            <mat-label>País</mat-label>
            <mat-select placeholder="Selecciona" required formControlName="country">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let countrie of countries"
                            value='{{countrie.name_es}}'>{{countrie.name_es}}</mat-option>
            </mat-select>
            <mat-error>Campo requerido</mat-error>
        </mat-form-field>
        <mat-form-field class="w-30" appearance="outline">
            <mat-label>Estado</mat-label>
            <input maxlength="50" required appOnlyLetters formControlName="state" matInput autocomplete="off"
                   type="text">
            <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
        </mat-form-field>
        <mat-form-field class="w-40" appearance="outline">
            <mat-label>Ciudad</mat-label>
            <input maxlength="50" required appOnlyLetters formControlName="city" matInput autocomplete="off"
                   type="text">
            <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
        </mat-form-field>
        <mat-form-field class="w-25" appearance="outline">
            <mat-label>Código postal</mat-label>
            <input  appOnlyNumbers minlength="4" maxlength="8"  required formControlName="code" matInput autocomplete="off"
                   type="text">
            <mat-error
                    *ngIf="!form.controls.code.hasError('required') && form.controls.code.hasError('minlength')">
                Longitud mínima de 4 dígitos
            </mat-error>
            <mat-error
                    *ngIf="form.controls.code.hasError('required')">
                Campo requerido.
            </mat-error>
        </mat-form-field>
        <mat-form-field class="w-70" appearance="outline">
            <mat-label>Dirección</mat-label>
            <input required maxlength="50" appToUppercase formControlName="address" matInput autocomplete="off"
                   type="text">
            <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
        </mat-form-field>
        <mat-form-field class="w-55" appearance="outline">
            <mat-label>RFC</mat-label>
            <input required appToUppercase formControlName="rfc" maxlength="13" matInput autocomplete="off" type="text">
            <mat-error *ngIf="form.controls.rfc.hasError('required')">Campo requerido</mat-error>
            <mat-error *ngIf="!form.controls.rfc.hasError('required') && form.controls.rfc.hasError('rfcFormat')">RFC
                inválido
            </mat-error>
        </mat-form-field>
        <mat-form-field class="w-40" appearance="outline">
            <mat-label>Razón social</mat-label>
            <input required maxlength="50" appToUppercase formControlName="businessName" matInput autocomplete="off"
                   type="text">
            <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
            <mat-label>USO de CFDI</mat-label>
            <mat-select placeholder="Selecciona" required formControlName="cfdiUses">
                <mat-option>--</mat-option>
                <mat-option value="G01 Adquisición de mercancías">G01 Adquisición de mercancías</mat-option>
                <mat-option value="G02 Devoluciones, descuentos o bonificaciones">G02 Devoluciones, descuentos o
                    bonificaciones
                </mat-option>
                <mat-option value="G03 Gastos en general">G03 Gastos en general</mat-option>
                <mat-option value="I01 Construcciones">I01 Construcciones</mat-option>
                <mat-option value="I02 Mobiliario y equipo de oficina por inversiones">I02 Mobiliario y equipo de
                    oficina por inversiones
                </mat-option>
                <mat-option value="I03 Equipo de transporte">I03 Equipo de transporte</mat-option>
                <mat-option value="I04 Equipo de cómputo y accesorios">I04 Equipo de cómputo y accesorios</mat-option>
                <mat-option value="I05 Dados, troqueles, moldes, matrices y herramental">I05 Dados, troqueles, moldes,
                    matrices y herramental
                </mat-option>
                <mat-option value="I06 Comunicaciones telefónicas">I06 Comunicaciones telefónicas</mat-option>
                <mat-option value="I07 Comunicaciones satelitales">I07 Comunicaciones satelitales</mat-option>
                <mat-option value="I08 Otra maquinaria y equipo">I08 Otra maquinaria y equipo</mat-option>
                <mat-option value="D01 Honorarios médicos, dentales y gastos hospitalarios">D01 Honorarios médicos,
                    dentales y gastos hospitalarios
                </mat-option>
                <mat-option value="D02 Gastos médicos por incapacidad o discapacidad">D02 Gastos médicos por incapacidad
                    o discapacidad
                </mat-option>
                <mat-option value="D03 Gastos funerales">D03 Gastos funerales</mat-option>
                <mat-option value="D04 Donativos">D04 Donativos</mat-option>
                <mat-option
                        value="D05 Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)">
                    D05 Intereses reales efectivamente pagados por créditos hipotecarios (casa
                    habitación)
                </mat-option>
                <mat-option value="D06 Aportaciones voluntarias al SAR">D06 Aportaciones voluntarias al SAR</mat-option>
                <mat-option value="D07 Primas por seguros de gastos médicos">D07 Primas por seguros de gastos médicos
                </mat-option>
                <mat-option value="D08 Gastos de transportación escolar obligatoria">D08 Gastos de transportación
                    escolar obligatoria
                </mat-option>
                <mat-option
                        value="D09 Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones">
                    D09 Depósitos en cuentas para el ahorro, primas que tengan como base planes de
                    pensiones
                </mat-option>
                <mat-option value="D10 Pagos por servicios educativos (colegiaturas)">D10 Pagos por servicios educativos
                    (colegiaturas)
                </mat-option>
                <mat-option value="P01 Por definir">P01 Por definir</mat-option>
            </mat-select>
            <mat-error>Campo requerido.</mat-error>
        </mat-form-field>
        <div class="actions">
            <div class="check">
                <mat-checkbox [(ngModel)]="acepptTerms" [ngModelOptions]="{standalone: true}"> Acepto el</mat-checkbox>
                <a class="link" [routerLink]="['/aviso-de-privacidad']" target="_blank">Aviso de Privacidad</a> y los
                <a class="link" [routerLink]="['/terminos-y-condiciones']" target="_blank">Términos y
                    condiciones.</a>
            </div>
            <button id="agregar_datos_facturacion_movil" [disabled]="form.invalid || !acepptTerms" mat-raised-button
                    (click)="saveData()"
                    class="black-button">
                Continuar
            </button>
        </div>
    </div>

    <div class="form" [formGroup]="formLatam"
         *ngIf="!billingAdded && addBilling === true && !this.sessionService.getCountryData()">
        <mat-form-field class="w-25" appearance="outline">
            <mat-label>País</mat-label>
            <mat-select placeholder="Selecciona" required formControlName="country">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let countrie of countries"
                            value='{{countrie.name_es}}'>{{countrie.name_es}}</mat-option>
            </mat-select>
            <mat-error>Campo requerido</mat-error>
        </mat-form-field>
        <mat-form-field class="w-30" appearance="outline">
            <mat-label>Estado</mat-label>
            <input maxlength="50" required appOnlyLetters formControlName="state" matInput autocomplete="off"
                   type="text">
            <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
        </mat-form-field>
        <mat-form-field class="w-40" appearance="outline">
            <mat-label>Ciudad</mat-label>
            <input maxlength="50" required appOnlyLetters formControlName="city" matInput autocomplete="off"
                   type="text">
            <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
        </mat-form-field>
        <mat-form-field class="w-25" appearance="outline">
            <mat-label>Código postal</mat-label>
            <input appToUppercase minlength="4" maxlength="8" required formControlName="code" matInput autocomplete="off"
                   type="text">
            <mat-error
                    *ngIf="!formLatam.controls.code.hasError('required') && formLatam.controls.code.hasError('minlength')">
                Longitud mínima de 4 dígitos
            </mat-error>
            <mat-error
                    *ngIf="formLatam.controls.code.hasError('required')">
                Campo requerido.
            </mat-error>
        </mat-form-field>
        <mat-form-field class="w-70" appearance="outline">
            <mat-label>Dirección</mat-label>
            <input required maxlength="50" appToUppercase formControlName="address" matInput autocomplete="off"
                   type="text">
            <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
        </mat-form-field>
        <mat-form-field class="w-55" appearance="outline">
            <mat-label>Tax Code/Identificador Fiscal</mat-label>
            <input required appToUppercase formControlName="rfc" minlength="5" matInput autocomplete="off" type="text">
            <mat-error>Campo requerido.</mat-error>
        </mat-form-field>
        <mat-form-field class="w-40" appearance="outline">
            <mat-label>Razón social</mat-label>
            <input required maxlength="50" appToUppercase formControlName="businessName" matInput autocomplete="off"
                   type="text">
            <mat-error>Digita mínimo 2 caracteres y máximo 50.</mat-error>
        </mat-form-field>
        <div class="actions">
            <div class="check">
                <mat-checkbox [(ngModel)]="acepptTerms" [ngModelOptions]="{standalone: true}"> Acepto el</mat-checkbox>
                <a class="link" [routerLink]="['/aviso-de-privacidad']" target="_blank">Aviso de Privacidad y los
                    Términos y
                    condiciones.</a>
            </div>
            <button id="agregar_datos_facturacion_movil_latam" [disabled]="formLatam.invalid || !acepptTerms"
                    mat-raised-button (click)="saveData()"
                    class="black-button">
                Continuar
            </button>
        </div>
    </div>

    <div class="form" *ngIf="addBilling === false">
        <div class="no-data">SIN DATOS DE FACTURACIÓN</div>
    </div>

    <div class="form">
        <div class="actions">
            <button *ngIf="!billingDataValid" mat-raised-button (click)="medataAdd()"
                    class="black-button-data">{{ !addBilling ? 'AGREGAR DATOS' : 'NO AGREGAR'}}</button>
        </div>
    </div>

    <div class="billing-added" *ngIf="billingAdded && addBilling === true">
        <div class="item">
            <div class="info">
                <p class="title">País</p>
                <p>{{billingData?.country}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">Código Postal</p>
                <p>{{billingData?.code}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">Estado</p>
                <p>{{billingData?.state}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item" *ngIf="this.sessionService.getCountryData()">
            <div class="info">
                <p class="title">RFC</p>
                <p>{{billingData?.rfc}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item" *ngIf="!this.sessionService.getCountryData()">
            <div class="info">
                <p class="title">Tax Code/Identificador Fiscal</p>
                <p>{{billingData?.rfc}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">Ciudad</p>
                <p>{{billingData?.city}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">Dirección</p>
                <p>{{billingData?.address}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>
    </div>
    <div class="form">
        <div class="edit-btn">
            <button mat-raised-button *ngIf="billingDataValid" (click)="refreshEmpty()" class="blanco-button">
                EDITAR
            </button>
        </div>
    </div>
    <div class="disabled" *ngIf="!active"></div>

</div>
